"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var Components_1 = require("./Components");
var SafeRedirect_1 = require("../../Components/SafeRedirect");
var Pages_1 = require("./Pages");
var Context_1 = require("./Context");
var GlobalContext_1 = require("../../Context/GlobalContext");
require("./Styles/Dashboard.css");
var Dashboard = /** @class */ (function (_super) {
    __extends(Dashboard, _super);
    function Dashboard(props) {
        return _super.call(this, props) || this;
    }
    Dashboard.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(Components_1.DashboardInfoBar, { resources: this.props.resources }),
            React.createElement(Context_1.DashboardContext.Provider, { value: { state: this.state, props: this.props } },
                React.createElement(GlobalContext_1.GlobalConsumer, null, function (context) { return context && (React.createElement(react_router_dom_1.Switch, null,
                    React.createElement(react_router_dom_1.Route, { exact: true, path: '/Dashboard/Safe', render: function () { return React.createElement(Pages_1.Safe, { applicationData: context }); } }),
                    React.createElement(react_router_dom_1.Route, { exact: true, path: '/Dashboard/Single', render: function () { return React.createElement(Pages_1.Single, { applicationData: context }); } }),
                    React.createElement(react_router_dom_1.Route, { exact: true, path: '/Dashboard/Multiple/:path4?', render: function () { return React.createElement(Pages_1.Multiple, { applicationData: context }); } }),
                    React.createElement(react_router_dom_1.Route, { exact: true, path: '/Dashboard/Reports/:path3?', render: function () { return React.createElement(Pages_1.Reports, { applicationData: context }); } }),
                    React.createElement(react_router_dom_1.Route, { exact: true, path: '/Dashboard/DeferredQueue', render: function () { return React.createElement(Pages_1.DeferredQueue, { applicationData: context }); } }),
                    React.createElement(react_router_dom_1.Route, { path: '/Dashboard/*', render: function () { return React.createElement(SafeRedirect_1.SafeRedirect, { to: "/Dashboard/Safe", resources: _this.props.resources }); } }))); }))));
    };
    return Dashboard;
}(React.Component));
exports.Dashboard = Dashboard;
//# sourceMappingURL=Dashboard.js.map